import { render } from "./Stage.vue?vue&type=template&id=6faf5c75"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"

import "./Stage.vue?vue&type=style&index=0&id=6faf5c75&lang=css"

import exportComponent from "D:\\project\\survey-slp-house\\survey-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__